import { useShowResponseStatus } from '@/shared';

import {
  useCreditH2HPaymentClientMutation,
  useFinalizeH2HPaymentMutation,
  useHideH2HPaymentFromQueueMutation,
  useRejectH2HPaymentMutation,
  useResolveH2HProviderConflictMutation,
  useReviewH2HDiscrepancyMutation,
} from '../store/h2h-payments-api';

import type { TH2HSettlementSource } from '../store/types';

export const useH2HPaymentActions = () => {
  const [creditClient, creditState] = useCreditH2HPaymentClientMutation();
  const [finalizePayment, finalizeState] = useFinalizeH2HPaymentMutation();
  const [rejectPayment, rejectState] = useRejectH2HPaymentMutation();
  const [resolveProviderConflict, resolveState] = useResolveH2HProviderConflictMutation();
  const [reviewDiscrepancy, reviewState] = useReviewH2HDiscrepancyMutation();
  const [hideFromQueue, hideFromQueueState] = useHideH2HPaymentFromQueueMutation();

  useShowResponseStatus({
    isSuccess: creditState.isSuccess,
    successMessage: 'Состояние H2H-платежа обновлено',
    isError: creditState.isError,
    errorMassage: 'Не удалось выполнить действие',
  });

  useShowResponseStatus({
    isSuccess: hideFromQueueState.isSuccess,
    successMessage: 'Заявка убрана из рабочих разделов и оставлена во «Всё»',
    isError: hideFromQueueState.isError,
    errorMassage: 'Не удалось убрать заявку из рабочих разделов',
  });

  useShowResponseStatus({
    isSuccess: finalizeState.isSuccess,
    successMessage: 'Состояние H2H-платежа обновлено',
    isError: finalizeState.isError,
    errorMassage: 'Не удалось выполнить действие',
  });

  useShowResponseStatus({
    isSuccess: rejectState.isSuccess,
    successMessage: 'Состояние H2H-платежа обновлено',
    isError: rejectState.isError,
    errorMassage: 'Не удалось выполнить действие',
  });

  useShowResponseStatus({
    isSuccess: resolveState.isSuccess,
    successMessage: 'Расхождение H2H-платежа подтверждено',
    isError: resolveState.isError,
    errorMassage: 'Не удалось подтвердить расхождение',
  });

  useShowResponseStatus({
    isSuccess: reviewState.isSuccess,
    successMessage: 'Расхождение отмечено проверенным',
    isError: reviewState.isError,
    errorMassage: 'Не удалось отметить расхождение проверенным',
  });

  return {
    isLoading: creditState.isLoading
      || finalizeState.isLoading
      || rejectState.isLoading
      || resolveState.isLoading
      || reviewState.isLoading
      || hideFromQueueState.isLoading,
    creditClient: (paymentId: number, paidAmount: string) => creditClient({ paymentId, paidAmount }),
    finalizePayment: (paymentId: number, settlementSource: TH2HSettlementSource) => (
      finalizePayment({ paymentId, settlementSource })
    ),
    rejectPayment: (paymentId: number, reason: string) => rejectPayment({ paymentId, reason }),
    resolveProviderConflict: (paymentId: number) => resolveProviderConflict(paymentId),
    reviewDiscrepancy: (paymentId: number) => reviewDiscrepancy(paymentId),
    hideFromQueue: (paymentId: number) => hideFromQueue(paymentId),
  };
};
